import { useState } from 'react';
import { createScopedLogger } from '~/utils/logger';
import { chatStore } from '~/lib/stores/chat';
import * as Sentry from '@sentry/remix';
import { userStore } from '~/lib/stores/user';

const logger = createScopedLogger('usePromptEnhancement');

export function usePromptEnhancer() {
  const [enhancingPrompt, setEnhancingPrompt] = useState(false);
  const [promptEnhanced, setPromptEnhanced] = useState(false);

  const resetEnhancer = () => {
    setEnhancingPrompt(false);
    setPromptEnhanced(false);
  };

  const enhancePrompt = async (input: string, setInput: (value: string) => void) => {
    setEnhancingPrompt(true);
    setPromptEnhanced(false);

    const { framework, language } = chatStore.get();

    const response = await fetch('/api/enhancer', {
      method: 'POST',
      body: JSON.stringify({
        message: input,
        framework,
        language,
      }),
    });

    const reader = response.body?.getReader();

    const originalInput = input;

    if (reader) {
      const decoder = new TextDecoder();

      let _input = '';
      let _error;

      try {
        setInput('');

        while (true) {
          const { value, done } = await reader.read();
          console.log('value: ', decoder.decode(value));

          if (done) {
            break;
          }

          console.log('value: ', decoder.decode(value));

          const decodedValue = decoder.decode(value);
          const cleanedValue = decodedValue.replace(/\[object Object\]+/g, '');
          _input += cleanedValue;

          logger.trace('Set input', _input);

          setInput(_input);
        }
      } catch (error) {
        Sentry.captureException(error, {
          extra: {
            message: 'Error during prompt enhancement',
            framework,
            language,
          },
        });
        _error = error;
        setInput(originalInput);
      } finally {
        if (_error) {
          logger.error(_error);
        }

        setEnhancingPrompt(false);
        setPromptEnhanced(true);

        setTimeout(() => {
          setInput(_input);
        });
      }
    }
  };

  return { enhancingPrompt, promptEnhanced, enhancePrompt, resetEnhancer };
}
